module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p-p2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('p', {
    staticClass: "p-p2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("DEVIL TREE "), _c('span', {
    staticClass: "s-t"
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "p-p4"
  }, [_c('span', {
    staticClass: "s-t1"
  }, [_vm._v("The Calling")])]), _vm._v(" "), _c('p', {
    staticClass: "p-p5"
  }, [_vm._v("KEITH ROMMEL")]), _vm._v(" "), _c('p', {
    staticClass: "whitespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "p-p6"
  }, [_vm._v("INSPIRED BY THE LEGEND OF THE DEVIL TREE")]), _vm._v(" "), _c('p', {
    staticClass: "p-p6"
  }, [_vm._v("IN PORT SAINT LUCIE, FLORIDA")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3acd0e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/index_split_000.vue
// module id = 57
// module chunks = 0